import store from '@/store/index';
const state = {
  ifFreshPrescriptionList: false,
  prescriptionSearchData: {
    // 不给初始这些属性，labelInput报错
    drugstore: '',
    patientName: '',
    date: '',
    prescriptionTotalStatus: '',
    advisoryType: ''
  },
  contactStorePid: '',
  videoPreDoctorInfo: {},
  yunxinAccount: {}
};
const mutations = {
  CHANGEifFreshPrescriptionListState(st, bl) {
    st.ifFreshPrescriptionList = bl;
  },
  SET_SEARCH_DATA(state, data) {
    state.prescriptionSearchData = { ...data };
  },
  SET_CONTACT_STORE_PID(state, pid) {
    state.contactStorePid = pid;
  },
  SET_PRE_DOCTOR_INFO(state, data) {
    state.videoPreDoctorInfo = { ...data };
  },
  SET_YUN_XIN_ACCOUNT(state, data) {
    state.yunxinAccount = { ...data };
  }
};

const actions = {
  async contactStoreVideo({ commit, state, dispatch, rootState }) {
    // const { vsPubSub, vsEvent } = rootState.video_trtcVideoStore;
    // vsPubSub.subscribe(vsEvent.USE_NERTCV1_CALL_2, async () => {
    //   const { contactStorePid } = state;
    //   if (!contactStorePid) return;
    //   let webRtc;
    //   try {
    //     // console.log('****newvideo****', 8);
    //     const res = state.yunxinAccount;
    //     // let res = await Fetch.get_yunxin_user_token_need_login({ prescriptionId: contactStorePid, connectType });
    //     const { name, account, toAccount, toName, patientName } = res;
    //     // 音视频操作: 待审处方，药师审方 店员->药师 (云信)
    //     const custom = JSON.stringify({
    //       data: {
    //         videoFrom: 'PHARMACIST',
    //         prescriptionId: contactStorePid,
    //         callName: name,
    //         message: `${name}邀请你进行视频`,
    //         groupTitle: `${patientName}的用药咨询`
    //       }
    //     });
    //
    //     webRtc = await dispatch('webRtc/initWebRtc', '', { root: true });
    //     // 为了保证video获取到大小，先打开框
    //     commit('video/SET_WEBRTC_STATUS', { key: 'isStartLocalCamera', value: true }, { root: true });
    //     // 打开本地摄像头
    //     webRtc && (await webRtc.startVideoPreview({}));
    //     dispatch(
    //       'video/setVideoInfo',
    //       {
    //         userInfo: { name, account, toAccount, toName },
    //         type: 1,
    //         custom: custom
    //       },
    //       { root: true }
    //     );
    //     await webRtc.startCallVideo(res.toAccount, { custom });
    //     dispatch('video/startVideoSuccessCb', '', { root: true });
    //   } catch (error) {
    //     console.log('error', error);
    //     dispatch('video/setVideoInital', '', { root: true });
    //   }
    // });
  },
  async contactStore({ commit, state, dispatch }, data) {
    console.log('contactStore', data);
    console.log(data);
    const { connectType } = data;
    const { contactStorePid } = state;
    if (!contactStorePid) return;
    // let webRtc;
    // try {
    let res = await Fetch.get_yunxin_user_token_need_login({ prescriptionId: contactStorePid, connectType });
    commit('SET_YUN_XIN_ACCOUNT', res);
    //账号啥的没用了 保留下用户信息 不然没信息
    const { name, account, toAccount, toName, patientName } = res;
    // 音视频操作: 待审处方，药师审方 店员->药师 (腾讯)
    // const custom = JSON.stringify({
    //   data: {
    //     videoFrom: 'PHARMACIST',
    //     prescriptionId: contactStorePid,
    //     callName: name,
    //     message: `${name}邀请你进行视频`,
    //     groupTitle: `${patientName}的用药咨询`
    //   }
    // });
    // webRtc = await dispatch('webRtc/initWebRtc', '', { root: true });
    // // 为了保证video获取到大小，先打开框
    // commit('video/SET_WEBRTC_STATUS', { key: 'isStartLocalCamera', value: true }, { root: true });
    // // 打开本地摄像头
    // webRtc && (await webRtc.startVideoPreview({}));
    // dispatch(
    //   'video/setVideoInfo',
    //   {
    //     userInfo: { name, account, toAccount, toName },
    //     type: 1,
    //     custom: custom
    //   },
    //   { root: true }
    // );
    // await webRtc.startCallVideo(res.toAccount, { custom });
    // dispatch('video/startVideoSuccessCb', '', { root: true });
    // console.log('===custommmm1', res, custom);
    const prescriptionId = contactStorePid;
    // const groupId =
    if (res.toAccount) {
      // dispatch(
      //   'video_trtcVideoStore/makeCall',
      //   {
      //     // contactId: '1389335477',
      //     contactId: res.toAccount.toString(),
      //     business: JSON.parse(custom),
      //     bizNo: contactStorePid,
      //     scene: 'DRUGSTORE_PATIENT_TO_PHARMACIST'
      //   },
      //   { root: true }
      // );
      const custom = {
        callName: name,
        // groupId,
        message: `${name}邀请你进行视频`,
        groupTitle: `${patientName}的用药咨询`,
        prescriptionId,
        videoFrom: 'PHARMACIST'
      };
      //药师店员通话
      dispatch(
        'video_controller/makeCall',
        {
          contactId: toAccount.toString(),
          business: custom,
          bizNo: contactStorePid,
          scene: 'DRUGSTORE_PATIENT_TO_PHARMACIST',
          channels: ['NERTCv1']
        },
        { root: true }
      );
    }
    // } catch (error) {
    //   console.log('error', error);
    //   dispatch('video/setVideoInital', '', { root: true });
    // }
  },
  setVideoPreDoctorInfo({ commit }, data) {
    commit('SET_PRE_DOCTOR_INFO', data);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
